import React from "react";
import {Container} from "react-bootstrap";
import {headingStyles, regularTextStyles} from "../Style";
import FooterTFAF from "./FooterTFAF";

const PageNotFound = props => {
    const handleNewQuoteClick = () => {
        window.location.href = '/vehicle';
    };
    return (
        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
            <Container fluid style={{flex: 1}}>
                <Container>
                    <>
                        <br/>
                        <br/>

                        <p style={headingStyles}>Oops!<br/> <span style={regularTextStyles}>You have reached a page that doesn't exist.</span>
                        </p>
                        <p style={regularTextStyles}> If you’re still interested in car insurance,
                            please {' '}
                            <span style={{
                                color: '#1851A3', textDecoration: "underline",
                                cursor: "pointer",
                            }}
                                  onClick={handleNewQuoteClick}>
                       get a quote
                </span>.</p>
                    </>

                </Container>
            </Container>
            <FooterTFAF/>
        </div>
    );
}

export default PageNotFound;
